import AnalysisAnswer from './AnalysisAnswer'
import QuestionConstants from './QuestionConstants'
import QuestionList from './QuestionList'
import QuestionStatus from './QuestionStatus'
import SubQuestions from './SubQuestions'
import QuestionPreConditions from './QuestionPreConditions'
import QuestionFooter from './QuestionFooter'

export {
  AnalysisAnswer, // 分析解答
  QuestionConstants, // 参数
  QuestionList, // 题目列表
  SubQuestions, // 小问
  QuestionStatus, // 序号, 答题状态 & 标签
  QuestionFooter, // 按钮
  QuestionPreConditions // 题目
}
